export const traditionalMedicineConst = {
  path: "/single-programs/traditional-medicine",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — НАРОДНАЯ МЕДИЦИНА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра, магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Народная медицина — знание, проверенное веками</h2>
      <p>
        Народная медицина объединяет древние традиции лечения и современные научные подходы. Программа направлена на изучение фитотерапии,
        аюрведы, массажных техник, диетологии, телесных практик и культурных традиций оздоровления.
      </p>
      <p>
        Студенты осваивают не только натуральные методы терапии, но и учатся понимать биопсихосоциальную природу здоровья человека, сочетая
        природные средства с профилактикой и заботой о качестве жизни.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Фитотерапия и лекарственные растения</li>
        <li>Народные методы оздоровления в разных культурах</li>
        <li>Основы традиционной китайской и восточной медицины</li>
        <li>Биоритмы, аюрведа, натуропатия</li>
        <li>Диетология и профилактическое питание</li>
        <li>Массаж и телесные терапии</li>
        <li>Психосоматика и восстановительные практики</li>
        <li>Энергетическая диагностика и холистический подход</li>
        <li>Этика и правовые аспекты альтернативной медицины</li>
      </ul>
      <p>
        Программа сочетает теорию и практику: студенты проходят обучение в центрах комплементарной медицины, лабораториях и спа-клиниках.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Специалист по альтернативной и традиционной медицине</li>
        <li>Фитотерапевт или консультант по натуральному лечению</li>
        <li>Практик телесных и энергетических техник</li>
        <li>Консультант по здоровому образу жизни и питанию</li>
        <li>Специалист в wellness- и spa-центрах</li>
        <li>Преподаватель или исследователь народных методик</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Интерес к природным и немедикаментозным методам лечения растёт по всему миру.</p>
      <p>
        <strong>Средний доход в Европе — от €30,000 до €60,000 в год,</strong> в зависимости от специализации и сферы деятельности.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Диплом европейского образца (бакалавр/магистр)</li>
        <li>Обучение доступно на русском и английском языках</li>
        <li>Возможность учиться очно или дистанционно</li>
        <li>Стажировки в wellness-центрах и натуропатических клиниках</li>
        <li>Совмещение научного и традиционного подхода</li>
        <li>Индивидуальный подход к каждому студенту</li>
      </ul>
      <h2>Учёба, которая возвращает к природе</h2>
      <p>
        Народная медицина — это не альтернатива, а дополнение. Мы обучаем специалистов, способных сочетать мудрость поколений с современными
        знаниями и вести людей к здоровью гармонично и осознанно.
      </p>
      <br />
      <p className="padding-left">
        «Народная медицина — это забота, традиции и сила природы. Мы готовим тех, кто лечит не только тело, но и душу.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Заполните онлайн-анкету, загрузите документы — и приёмная комиссия свяжется с вами. Мы поможем начать обучение в ближайшем потоке.{" "}
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра, магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Народная медицина — знание, проверенное веками
    Народная медицина объединяет древние традиции лечения и современные научные подходы. Программа направлена на изучение фитотерапии, аюрведы, массажных техник, диетологии, телесных практик и культурных традиций оздоровления.
    Студенты осваивают не только натуральные методы терапии, но и учатся понимать биопсихосоциальную природу здоровья человека, сочетая природные средства с профилактикой и заботой о качестве жизни.

    Что вы будете изучать?
    • Фитотерапия и лекарственные растения
    • Народные методы оздоровления в разных культурах
    • Основы традиционной китайской и восточной медицины
    • Биоритмы, аюрведа, натуропатия
    • Диетология и профилактическое питание
    • Массаж и телесные терапии
    • Психосоматика и восстановительные практики
    • Энергетическая диагностика и холистический подход
    • Этика и правовые аспекты альтернативной медицины
    Программа сочетает теорию и практику: студенты проходят обучение в центрах комплементарной медицины, лабораториях и спа-клиниках.

    Кем можно работать после окончания?
    • Специалист по альтернативной и традиционной медицине
    • Фитотерапевт или консультант по натуральному лечению
    • Практик телесных и энергетических техник
    • Консультант по здоровому образу жизни и питанию
    • Специалист в wellness- и spa-центрах
    • Преподаватель или исследователь народных методик

    Востребованность и доход
    Интерес к природным и немедикаментозным методам лечения растёт по всему миру.
    Средний доход в Европе — от €30,000 до €60,000 в год, в зависимости от специализации и сферы деятельности.

    Почему выбирают нас?
    • Диплом европейского образца (бакалавр/магистр)
    • Обучение доступно на русском и английском языках
    • Возможность учиться очно или дистанционно
    • Стажировки в wellness-центрах и натуропатических клиниках
    • Совмещение научного и традиционного подхода
    • Индивидуальный подход к каждому студенту

    Учёба, которая возвращает к природе
    Народная медицина — это не альтернатива, а дополнение. Мы обучаем специалистов, способных сочетать мудрость поколений с современными знаниями и вести людей к здоровью гармонично и осознанно.
    «Народная медицина — это забота, традиции и сила природы. Мы готовим тех, кто лечит не только тело, но и душу.»

    Как поступить?
    Заполните онлайн-анкету, загрузите документы — и приёмная комиссия свяжется с вами. Мы поможем начать обучение в ближайшем потоке.
  `,
};
